import { Injectable } from '@angular/core';
import { PoMultiselectOption } from '@po-ui/ng-components';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { APISCockpit } from 'src/service/apis-cockpit';
import { CostGroupFilter } from './costgroupfilter';


const API = '/api/construction-projects/v1/cost-groups?';

@Injectable({ providedIn: 'root' })
export class CostGroupFilterService {

  optionsMultiSelect: Array<PoMultiselectOption>;
  optionsTotal: Array<CostGroupFilter>;
  optionsGlb: Array<CostGroupFilter>;
  constructor(private apiCockpit: APISCockpit,
    private contextAplication: ContextApplication) { }

  async GetCostGroupOptions() {
    this.optionsMultiSelect = [];
    this.optionsTotal = [];
    if (this.contextAplication.HasContext) {
      const url: string = API + this.contextAplication.Filter;
      const urlGlobal: string = API + 'companyId=' + this.contextAplication.Project.companyId +
        '&projectId=' + 0;
      const result = await this.apiCockpit.getDataInfo(url);

      const options = result.items as Array<CostGroupFilter>;

      await this.apiCockpit
        .getDataInfo(urlGlobal)
        .then(ret => {
          this.optionsGlb = ret.items as Array<CostGroupFilter>;
          this.optionsGlb.forEach(y => y.description = y.description + ' (G)');
          this.optionsTotal = this.optionsTotal.concat(options, this.optionsGlb);
        })
        .catch(() => this.optionsTotal = options);

      this.optionsTotal.forEach(x => this.optionsMultiSelect = [...this.optionsMultiSelect, { label: x.description, value: x.id }]);
      return this.optionsMultiSelect;
      ;

    }
    else {
      return this.optionsMultiSelect;
    }
  }

}

